import React from 'react';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import OutlinedInput from '@material-ui/core/OutlinedInput';

const renderFromHelper = ({touched, invalid, error, helperText}) => {
    if (!error && !helperText) {
        return null;
    } else {
        return <FormHelperText error={invalid || Boolean(error)}>{(invalid && error) || helperText}</FormHelperText>;
    }
};

const renderSelectField = ({
                               input,
                               variant,
                               label,
                               helperText,
                               meta: {touched, invalid, error},
                               fullWidth,
                               children,
                               ...custom
                           }) => {

    const inputLabel = React.useRef(null);
    const [labelWidth, setLabelWidth] = React.useState(0);
    label && React.useEffect(() => {
        setLabelWidth(inputLabel.current.offsetWidth);
    }, []);

    const outlinedProps = {
        id: `select-${input.name}`,
        name: input.name,
        fullWidth,
    };

    if (label) {
        outlinedProps.labelWidth = labelWidth;
    }

    const inputElement = variant && variant === 'outlined' ? <OutlinedInput {...outlinedProps} /> : undefined;
    const inputProps = {
        name: input.name,
        id: `select-${input.name}`,
    };

    const selectProps = {
        ...input,
        ...custom,
        input: inputElement,
        fullWidth,
        inputProps,
    };

    return (
        <FormControl variant={variant} fullWidth={fullWidth} error={invalid || Boolean(error)}>
            {label && <InputLabel ref={inputLabel} htmlFor={`select-${input.name}`}>{label}</InputLabel>}
            <Select {...selectProps}>
                {children}
            </Select>
            {renderFromHelper({touched, invalid, error, helperText})}
        </FormControl>
    );
};

export {renderFromHelper, renderSelectField};
export default renderSelectField;